<template>
  <component :is="selectedInsight" :insight="insight"></component>
</template>

<script>
import { mapGetters } from 'vuex';
import FeesInsight from './FeesInsight';
import NegativeBalanceInsight from './NegativeBalanceInsight';
import ChallengeInsight from './ChallengeInsight';
import HighIncomeInsight from './HighIncomeInsight';
import LoanInsight from './LoanInsight';
import HighExpenseInsight from './HighExpenseInsight';
import EconomyBalanceInsight from './EconomyBalanceInsight';
import ZeroBalanceInsight from './ZeroBalanceInsight.vue';
import MightBeFixedInsight from './MightBeFixedInsight';
import FixBalanceInsight from './FixBalanceInsight';
import RecurringBalanceInsight from './RecurringBalanceInsight';
import ActivationInsight from './ActivationInsight';
import TrackingInsight from './TrackingInsight';
import OpportunisticSavingInsight from './OpportunisticSavingInsight';
import MonthlySavingInsight from './MonthlySavingInsight';
import HarelMonthlySavingInsight from './HarelMonthlySavingInsight.vue';
import DemographicInfoInsight from './DemographicInfoInsight';
import RollingCreditInsight from './RollingCreditInsight';
import MeitavOpportunisticSavingInsight from './MeitavOpportunisticSavingInsight';
import MeitavMonthlySavingInsight from './MeitavMonthlySavingInsight';

export default {
  name: 'InsightFactory',
  components: {
    HighIncomeInsight,
    LoanInsight,
    HighExpenseInsight,
    EconomyBalanceInsight,
    MightBeFixedInsight,
    FixBalanceInsight,
    ZeroBalanceInsight,
    RecurringBalanceInsight,
    ActivationInsight,
    OpportunisticSavingInsight,
    MonthlySavingInsight,
    HarelMonthlySavingInsight,
    DemographicInfoInsight,
    FeesInsight,
    NegativeBalanceInsight,
    RollingCreditInsight,
    MeitavOpportunisticSavingInsight,
    MeitavMonthlySavingInsight,
    ChallengeInsight,
  },
  props: {
    insight: { type: Object },
  },
  computed: {
    ...mapGetters('insights', ['INSIGHT_NAMES']),
    allInsightComponents() {
      return {
        [this.INSIGHT_NAMES.LoanExclusion]: LoanInsight,
        [this.INSIGHT_NAMES.HighIncomeExclusion]: HighIncomeInsight,
        [this.INSIGHT_NAMES.RelativeIncomeExclusion]: HighIncomeInsight,
        [this.INSIGHT_NAMES.FeesInsight]: FeesInsight,
        [this.INSIGHT_NAMES.NegativeBalanceInsight]: NegativeBalanceInsight,
        [this.INSIGHT_NAMES.ChallengeInsight]: ChallengeInsight,
        [this.INSIGHT_NAMES.HighExpense]: HighExpenseInsight,
        [this.INSIGHT_NAMES.RelativeHighExpense]: HighExpenseInsight,
        [this.INSIGHT_NAMES.EconomyBalance]: EconomyBalanceInsight,
        [this.INSIGHT_NAMES.MightBeFixed]: MightBeFixedInsight,
        [this.INSIGHT_NAMES.FixedBalance]: FixBalanceInsight,
        [this.INSIGHT_NAMES.ZeroBalance]: ZeroBalanceInsight,
        [this.INSIGHT_NAMES.RecurringBalance]: RecurringBalanceInsight,
        [this.INSIGHT_NAMES.Activation]: ActivationInsight,
        [this.INSIGHT_NAMES.TrackingCategories]: TrackingInsight,
        [this.INSIGHT_NAMES.OpportunisticSaving]: OpportunisticSavingInsight,
        [this.INSIGHT_NAMES.MonthlySaving]: MonthlySavingInsight,
        [this.INSIGHT_NAMES.HarelMonthlySaving]: HarelMonthlySavingInsight,
        [this.INSIGHT_NAMES.DemographicInfo]: DemographicInfoInsight,
        [this.INSIGHT_NAMES.RollingCreditInsight]: RollingCreditInsight,
        [this.INSIGHT_NAMES.MeitavOpportunisticSaving]: MeitavOpportunisticSavingInsight,
        [this.INSIGHT_NAMES.MeitavMonthlySaving]: MeitavMonthlySavingInsight,
      };
    },
    selectedInsight() {
      return this.allInsightComponents[this.insight.insightName];
    },
  },
};

</script>

<style lang="scss" scoped>
</style>
